module.exports = __webpack_public_path__ + "img/album13_12.16c0e071.jpg";